var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomise = function SvgCustomise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customise_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.758,
    height: 30.758,
    x: 39.242,
    y: 9.015,
    fill: "#B4CFFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.758,
    height: 30.758,
    x: 20.151,
    y: 23.864,
    fill: "#6C9BF1",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.758,
    height: 30.758,
    x: 1.061,
    y: 38.712,
    fill: "#2F68D1",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M10.606 29.167c-.476-4.597-.938-6.9-2.322-8.284S4.597 19.037 0 18.56c4.597-.477 6.9-.938 8.284-2.322s1.846-3.687 2.322-8.284c.476 4.597.938 6.9 2.322 8.284s3.687 1.845 8.284 2.322c-4.597.476-6.9.938-8.284 2.322-1.384 1.383-1.846 3.687-2.322 8.284M26.515 17.5c-.238-2.299-.469-3.45-1.16-4.142-.693-.692-1.844-.923-4.143-1.161 2.299-.238 3.45-.469 4.142-1.16.692-.693.923-1.844 1.161-4.143.238 2.299.47 3.45 1.161 4.142s1.844.923 4.142 1.161c-2.298.238-3.45.469-4.142 1.161s-.923 1.843-1.16 4.142M18.03 6.894c-.143-1.38-.281-2.07-.696-2.485s-1.106-.554-2.486-.697c1.38-.143 2.07-.281 2.486-.696.415-.416.553-1.107.696-2.486.143 1.38.282 2.07.697 2.486.415.415 1.106.553 2.485.696-1.379.143-2.07.282-2.485.697s-.554 1.106-.697 2.485"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customise_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgCustomise;